import { lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import MainLayout from "../layouts/MainLayout";

const ContactPage = lazy(() => import("../pages/contact/ContactPage"));
const AboutPage = lazy(() => import("../pages/about/AboutPage"));
const HomePage = lazy(() => import("../pages/home/HomePage"));
// const PlaygroundPage = lazy(() => import("../pages/playground/PlaygroundPage"));
const ProjectsPage = lazy(() => import("../pages/projects/ProjectsPage"));
const SkillsPage = lazy(() => import("../pages/skills/SkillsPage"));

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="skills" element={<SkillsPage />} />
          <Route path="about" element={<AboutPage />} />
          {/* <Route path="playground" element={<PlaygroundPage />} /> */}
          <Route path="contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
